module.exports = __webpack_public_path__ + "img/8.255c6b4f.jpg";